//Types Alertas
export const MOSTRAR_ALERTA = 'MOSTRAR_ALERTA';
export const OCULTAR_ALERTA = 'OCULTAR_ALERTA'

//Types Cuentas
export const OBTENER_CUENTAS = 'OBTENER_CUENTAS';
export const ELIMINAR_CUENTA = 'ELIMINAR_CUENTA';

//Types Solicitudes
export const OBTENER_SOLICITUDES = 'OBTENER_SOLICITUDES';
export const ELIMINAR_SOLICITUD = 'ELIMINAR_SOLICITUD';
export const ELIMINAR_SOLICITUDES = 'ELIMINAR_SOLICITUDES';
export const ACTUALIZAR_SOLICITUD = 'ACTUALIZAR_SOLICITUD';
export const SOLICITUD_REGISTRADA = 'SOLICITUD_REGISTRADA';
export const SOLICITUD_ERROR = 'SOLICITUD_ERROR';
export const OBTENER_SOLICITUDES_DPTO = 'OBTENER_SOLICITUDES_DPTO';

//Types Login/Registro/CerrarSesion
export const REGISTRO_EXITOSO = 'REGISTRO_EXITOSO';
export const REGISTRO_ERROR = 'REGISTRO_ERROR';
export const OBTENER_USUARIO = 'OBTENER_USUARIO';
export const LOGIN_EXITOSO = 'LOGIN_EXITOSO';
export const LOGIN_ERROR = 'LOGIN_ERROR';
export const CERRAR_SESION = 'CERRAR_SESION';